// extracted by mini-css-extract-plugin
module.exports = {"button":"trash-button_button__1lrs2","icon":"trash-button_icon__2LwCg"};